import CloseIcon from "@mui/icons-material/Close";
import {
  Avatar,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  IconButton,
  Typography
} from "@mui/material";

const ConfirmStartBidModal: React.FC<any> = ({
  open,
  onClose,
  onConfirm,
  player,
}) => {
  if (!player) return null;

  const nameParts = player.name.trim().split(" ");
  const firstName = nameParts[0];
  const lastName = nameParts.slice(1).join(" ");

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          background: "#0D0D0D",
          border: "0.5px solid rgba(255, 255, 255, 0.20)",
          borderRadius: "16px",
          p: "32px",
          width: "500px",
        },
      }}
    >
      <DialogTitle
        sx={{
          p: "0px",
          pb: "12px",
          color: "#fff",
          fontWeight: "bold",
          fontSize: "20px",
          borderBottom: "1px solid #ffffff33",
        }}
      >
        Confirm to Proceed
        <IconButton
          onClick={onClose}
          sx={{ float: "right", color: "#fff", p: "0px" }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        mt={"36px"}
      >
        <Avatar
          src={player.photo}
          alt={player.name}
          sx={{
            width: "124px",
            height: "124px",
            mb: "1vw",
            border: "0.5px solid #5C5C5C",
          }}
        />
        <Typography
          sx={{ fontWeight: 600, fontSize: "20px", color: "#fff", mb: "1px" }}
        >
          {firstName} {lastName}
        </Typography>
        <Typography sx={{ color: "#bdbdbd", mb: 2 }}>{player.MCANo}</Typography>
        <Typography
          sx={{
            fontSize: "20px",
            fontWeight: 500,
            textAlign: "center",
            width: "80%",
            color: "#fff",
            mt: "20px",
          }}
        >
          Are you sure you want to start the bidding for this player?
        </Typography>
      </Box>
      <DialogActions sx={{ justifyContent: "center", pb: 2, mt: "1.3vw" }}>
        <Button
          onClick={onConfirm}
          sx={{
            height: "48px",
            background: "#fff",
            color: "#000",
            px: 3,
            borderRadius: "8px",
            fontSize: "16px",
            fontWeight: "500",
            flex: 1,
            "&:hover": {
              background: "#fff",
            },
          }}
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmStartBidModal;
